import React, { useEffect, useState } from 'react'
import Head from 'next/head'
import { ThemeProvider } from '@mui/material'
import MainWrapper from '@/components/MainWrapper'
import styles from './HomeLayout.module.scss'
import { setConsent } from '@/modules/consentService'
import { IConsent } from '@/modules/consentService/interfaces'
import ConsentPopup from '@/components/ConsentPopup'
import { primary as primaryTheme } from '@/modules/themeService'
import { MINISTRY, MINISTRY_DESCRIPTION } from '@/modules/stringService'

interface LayoutProps {
  children: React.ReactNode;
}

const HomeLayout: React.FC<LayoutProps> = ({ children }) => {
  const [consent, changeConsent] = useState<IConsent | null>(null)

  // Effect to run only on client side
  useEffect(() => {
    const stored = window.localStorage.getItem('consent')
    const val = stored ? (JSON.parse(stored) as IConsent) : null
    // console.log({ val })
    // setConsent({ ...consent, ...val })
    if (val) changeConsent(val)
  }, [])

  const updateConsent = (form: IConsent | null): void => {
    setConsent(form)
    changeConsent(form)
  }

  return (
    <>
      <Head>
        <meta name="description" content={MINISTRY_DESCRIPTION} />
        <meta name="robots" content="index, follow" />
        <meta name="viewport" content="width=device-width, initial-scale=1" />
        <link rel="icon" href="/favicon.ico" />
        {/* Open Graph */}
        <meta property="og:title" content={MINISTRY} />
        <meta property="og:description" content={MINISTRY_DESCRIPTION} />
        <meta property="og:type" content="website" />
        <meta property="og:site_name" content={MINISTRY} />
        <meta property="og:image" content="/img/og-image@630x-100.jpg" />
        <meta property="og:image:width" content="1200" />
        <meta property="og:image:height" content="630" />
        <style>{'body { background-color: var(--secondary-color); }'}</style>
      </Head>
      <ThemeProvider theme={primaryTheme}>
        <div className={styles.wrapper}>
          <MainWrapper>
            {children}
            {consent === null &&
              <ConsentPopup updateConsent={(obj) => updateConsent(obj)} />
            }
          </MainWrapper>
        </div>
      </ThemeProvider>
    </>
  )
}

export default HomeLayout
